import { observer } from 'mobx-react';
import React from 'react';
import icons from '@icons';
import { declension } from '@utils/declension';
import { Picture } from '@ui';
import './index.scss';
const {
  cube: { white: cubeOutlinedWhite }
} = icons.Outline;

const InStoreBlock = observer(
  ({
    multiPricePromo,
    isDesktop,
    isBarMenuCurrentPath,
    productCount,
    deliveryDate,
    countInStore,
    specialPriceData
  }) => {
    const countText =
      countInStore > 10
        ? 'Есть на складе'
        : `На складе ${countInStore} ${declension(countInStore, [
            'штука',
            'штуки',
            'штук'
          ])}`;
    return (
      <div className='InStoreBlock'>
        <div className='InStoreBlock__count'>{productCount || ''}</div>
        {!isBarMenuCurrentPath && (
          <div className='InStoreBlock__date'>Доступен {deliveryDate}</div>
        )}
        {deliveryDate?.toLowerCase('сегодня') === '' &&
          deliveryDate?.toLowerCase() === 'завтра' && (
            <div className='InStoreBlock__in-store'>
              <Picture
                className='InStoreBlock__in-store__icon'
                icon={cubeOutlinedWhite}
                height={isDesktop ? '20' : '12'}
              />
              {countText}
            </div>
          )}
        {specialPriceData && (
          <div className='InStoreBlock__special'>
            {specialPriceData.price1Kg || specialPriceData.price} ₽ от{' '}
            {specialPriceData.amount} шт
          </div>
        )}
        {multiPricePromo && (
          <div className='text-[10px] fromLg:text-xs leading-none py-1 px-2 rounded bg-[var(--dark-red)]'>
            Первые {multiPricePromo.buy_at_once} шт по{' '}
            {multiPricePromo?.weightPriceData
              ? multiPricePromo?.weightPriceData?.price
              : multiPricePromo.price_active}
            ₽
          </div>
        )}
      </div>
    );
  }
);

export default InStoreBlock;
